import { motion, Variants, Easing } from "framer-motion";
import { openContactForm } from "../../Functions/contactFormFunctions";
import Section from "../Common/Section";
import Card from "../Common/Card";
import "./style.scss";

interface WhatIsUsProps {
  order?: "odd" | "even";
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" as Easing },
  },
};

const WhatIsUs: React.FC<WhatIsUsProps> = ({ order }) => {
  const locations = [
    "Farnham",
    "Aldershot",
    "Alton",
    "Fleet",
    "Badshot Lea",
    "Ash",
    "Bentley",
    "Beacon Hill",
    "And more...",
  ];

  return (
    <Section variant={order} className="WhatIsUs">
      <motion.div className="sectionHeader" variants={itemVariants}>
        <h2 className="title">Why Choose Us?</h2>
        <p className="subtitle">
          With over 5 decades of experience, we provide a service you can trust.
        </p>
      </motion.div>

      <motion.div className="featuresGrid" variants={containerVariants}>
        <Card variants={itemVariants} className="featureItem">
          <span className="material-symbols-outlined icon">history</span>
          <h3>Trusted Since 1972</h3>
          <p>
            A family-run business with a legacy of quality and reliability in
            the Farnham area.
          </p>
        </Card>
        <Card variants={itemVariants} className="featureItem">
          <span className="material-symbols-outlined icon">layers</span>
          <h3>Diverse Services</h3>
          <p>
            From residential windows to commercial cleaning and gutter
            maintenance.
          </p>
        </Card>
        <Card variants={itemVariants} className="featureItem">
          <span className="material-symbols-outlined icon">verified</span>
          <h3>Guaranteed Quality</h3>
          <p>
            We take pride in our work, ensuring a streak-free finish that lasts.
          </p>
        </Card>
      </motion.div>

      <motion.div className="locationsSection" variants={itemVariants}>
        <h3 className="locationsTitle">Serving Your Local Area</h3>
        <div className="locationBadges">
          {locations.map((loc, index) => (
            <span key={index} className="locationBadge">
              {loc}
            </span>
          ))}
        </div>
        <p className="enquiryText">
          Don't see your area?{" "}
          <span className="link" onClick={() => openContactForm()}>
            Enquire now
          </span>
        </p>
      </motion.div>
    </Section>
  );
};

export default WhatIsUs;
